import { render, staticRenderFns } from "./privacyAgreementC.vue?vue&type=template&id=602e2128&scoped=true&"
import script from "./privacyAgreementC.vue?vue&type=script&lang=js&"
export * from "./privacyAgreementC.vue?vue&type=script&lang=js&"
import style0 from "./privacyAgreementC.vue?vue&type=style&index=0&id=602e2128&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "602e2128",
  null
  
)

export default component.exports